export const iconFontAwesomeBuildingsHouse = (
	<i className="fa-solid fa-house"></i>
);
